import { boronClient } from "../../api";
import { useBoronMutation } from "../../hooks/http/useBoronMutation";
import { StudyRecordSkillParamsInterface } from "../../interfaces/StudyRecordSkillInterface";

export const usePostSkill = ({ sectionId }: { sectionId: string }) => {
  return useBoronMutation(
    async (params: StudyRecordSkillParamsInterface) =>
      await boronClient.POST("/api/v1/sections/{section_id}/skills", {
        params: {
          path: {
            section_id: sectionId,
          },
        },
        body: params,
      }),
  );
};
